export const routes = [
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('C:/Git/VueCore/vueapp/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/accounts',
    name: '/accounts',
    component: () => import('C:/Git/VueCore/vueapp/src/pages/accounts.vue'),
    children: [
      {
        path: 'chat',
        name: '/accounts/chat',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/accounts/chat.vue'),
        /* no children */
      },
      {
        path: 'main',
        /* internal name: '/accounts/main' */
        /* no component */
        children: [
          {
            path: ':search?',
            name: '/accounts/main/[[search]]',
            component: () => import('C:/Git/VueCore/vueapp/src/pages/accounts/main/[[search]].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/admin',
    name: '/admin',
    component: () => import('C:/Git/VueCore/vueapp/src/pages/admin.vue'),
    children: [
      {
        path: 'controls',
        name: '/admin/controls',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/admin/controls.vue'),
        /* no children */
      },
      {
        path: 'site',
        name: '/admin/site',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/admin/site.vue'),
        /* no children */
      },
      {
        path: 'users',
        name: '/admin/users',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/admin/users.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: 'login',
        name: '/auth/login',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/auth/login.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/content',
    name: '/content',
    component: () => import('C:/Git/VueCore/vueapp/src/pages/content.vue'),
    children: [
      {
        path: 'main',
        name: '/content/main',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/content/main.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/home',
    name: '/home',
    component: () => import('C:/Git/VueCore/vueapp/src/pages/home.vue'),
    children: [
      {
        path: 'dotnetnotes',
        name: '/home/dotnetnotes',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/home/dotnetnotes.vue'),
        /* no children */
      },
      {
        path: 'intro',
        name: '/home/intro',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/home/intro.vue'),
        /* no children */
      },
      {
        path: 'vuenotes',
        name: '/home/vuenotes',
        component: () => import('C:/Git/VueCore/vueapp/src/pages/home/vuenotes.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/menu',
    name: '/menu',
    component: () => import('C:/Git/VueCore/vueapp/src/pages/menu.vue'),
    /* no children */
  },
  {
    path: '/panzoom',
    name: '/panzoom',
    component: () => import('C:/Git/VueCore/vueapp/src/pages/panzoom.vue'),
    /* no children */
  },
  {
    path: '/test',
    name: '/test',
    component: () => import('C:/Git/VueCore/vueapp/src/pages/test.vue'),
    /* no children */
  }
]
